module.exports = __webpack_public_path__ + "static/rhb-f1608558290f2f70e347f58cbcc5b325.png";